import MainContainer from '../../../components/ui_components/MainContainer';
import styled from 'styled-components';
import buttonsForumObj from '../../../components/stats_components/buttonsForumObj';
import colors from '../../../styles/colors';

const Wrapper = styled.div`
    width: 90%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;

    & .info-stats-forum-mobile {
        font-size: 15px;
        font-weight: 600;
        color: white;
        letter-spacing: 3px;
        text-align: center;
        margin: 0;
        padding: 0;
    }
`;

const BoxAllButtons = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;
    padding: 20px 0;
`;

const SpaceButtonStatForum = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    & button.button-stats-forum-mobile {
        width: 50%;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${colors.bgColorBlack2};
        color: white;
        border: 2px solid white;
        border-radius: 5px;
        padding: 2px 7px;
        cursor: pointer;
        transition: all 0.2s ease;
        font-size: 15px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 2px;
        margin-top: 2px;
        box-shadow: 0 0 10px rgba(0,0,0,0.5);

        &:hover {
            background-color: ${colors.bgColorBordeaux};
            color: white;
            border: 2px solid white;
            transform: scale(1.05);
            transition: all 0.3s ease;
        }
    }
`;

const StatsForumMobile = () => {
    const buttons = buttonsForumObj;
    
    return (
        <MainContainer isMobile={true} className={`main-container-mobile-stats-forum`}>
            <Wrapper className='wrapper-stats-forum-mobile'>
                <p className='info-stats-forum-mobile'>
                    I pulsanti rimandano a specifiche pagine di statistiche presenti sul forum.
                </p>

                <BoxAllButtons className='box-all-buttons-stats-forum-mobile'>
                    {buttons.map((button, index) => (
                        <SpaceButtonStatForum key={index} className='space-button-stats-forum-mobile'>
                            <button className='button-stats-forum-mobile' onClick={() => window.open(button.url, '_blank')}>
                                {button.title}
                            </button>
                        </SpaceButtonStatForum>
                    ))}
                </BoxAllButtons>
            </Wrapper>
        </MainContainer>
    );
};

export default StatsForumMobile;